import {Injectable} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {RouteDataService} from "../route-data/route-data.service";
import {BehaviorSubject} from "rxjs";
import {DbResponse} from "../../interceptors/db-response";
import {RequesterService} from "../requester/requester.service";
import * as fromStore from "../../../store/";
import {Store} from "@ngrx/store";
import {filter, map} from "rxjs/operators";
import {CookieService} from "ngx-cookie";

@Injectable()
export class GoogleAnalyticsService {

  private currentWorkspaceId: number;

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _routeDataService: RouteDataService,
    private _requester: RequesterService,
    private _store: Store<fromStore.DbStoreState>,
    private _cookieService: CookieService
  ) {
    this._store.select(fromStore.getWorkspaceIdEntities).subscribe(workspaceIdEntities => {
      this.currentWorkspaceId = workspaceIdEntities.currentWorkspaceId || workspaceIdEntities.ownerWorkspaceId;
    });
  }


  public sendEventForOptimize(data): BehaviorSubject<DbResponse> {
    return new BehaviorSubject<DbResponse>(null);
  }


  public sendAnalyticsEventWithCore(data): BehaviorSubject<DbResponse> {
    return new BehaviorSubject<DbResponse>(null);
  }

  public sendAnalyticsEventWithCoreWithoutUserData(data): BehaviorSubject<DbResponse> {
    return new BehaviorSubject<DbResponse>(null);
  }
}
